export const isCtrlKey = (e) => {
    return e.metaKey || e.ctrlKey;
};

export const isShiftKey = (e) => {
    return e.shiftKey;
};
